import React from "react";
import styled, {css} from 'styled-components';
import {BrowserRouter as Router,Link, Route} from "react-router-dom";
import githubpic from '../pictures/github.png';
import qiitapic from '../pictures/qiita-square.jpg';
import twitterpic from '../pictures/twitter.png'; 

class Header extends React.Component {
    render(){
    const globalStyles = css`
    `
    const LinkStyled = styled(Link)`
        ${globalStyles}
    `
    const LinkStyledButton = styled(LinkStyled)`
        background-color: #0F4137;
        color: white;
        text-decoration: none;
    `
    const HEADER = styled.div`
        width: 100%
        height:calc(30px + 3vw);
        position: fixed;
        background-color: #0F4137;
        display: flex;
    `;
    
    const HEADERTITLE= styled.p`
        line-height: calc(8px + 0.5vw);
        padding-left: 1em;
        font-size: calc(13px + 1.3vw);
        color: white;
    `;
    
    const ICONBOX = styled.div`
        margin-left: auto;
    `;
    
    const ICON = styled.img`
        width: calc(13px + 1vw);
        height: calc(13px + 1vw);
        padding: calc(6px + 1vw);
    `;

return(
    <HEADER>
        <LinkStyledButton to='/'>
        <HEADERTITLE>YUKI'S PORTFOLIO</HEADERTITLE>
        </LinkStyledButton>
        <ICONBOX>
            <a href="https://github.com/YukiAmakawa" target="_blank">
                <ICON src= {githubpic} />
            </a>
            <a href="https://qiita.com/Yuki_A" target="_blank">
                <ICON src= {qiitapic} />
            </a>
            <a href="https://twitter.com/YuKi313230323?lang=ja" target="_blank">
                <ICON src= {twitterpic} />
            </a>
        </ICONBOX>
    </HEADER>
)}}
    
export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js